import React from "react";
import { useSelector } from "react-redux";
import { camelCase, isEqual, upperFirst } from "lodash";

// styling
import { css } from "emotion";
import colors from "../../../style/colors";
import { AccountAlertIcon, AccountCheckIcon, CheckIcon, ClipboardAccountIcon, StarIcon } from "mdi-react";
import punchStatuses from "../../../config/punchStatuses";
import InlineSpinner from "../../ui/InlineSpinner";
import Notification from "../../ui/Notification";

function PunchStatus({ count = null, isLoading = false, status, offsetBottom = true, notifications }) {
  const countSection =
    count !== null ? (
      isLoading && status !== "Assigned To You" ? (
        <>
          (<InlineSpinner size={10} style={{ marginTop: "10px" }} />)
        </>
      ) : status === "Assigned To You" ? (
        notifications > 0 ? (
          <Notification isLoading={isLoading} notifications={notifications} />
        ) : (
          <></>
        )
      ) : (
        `(${count})`
      )
    ) : (
      ""
    );

  return (
    <div className={container(offsetBottom) + ` ${upperFirst(camelCase(status))}`}>
      {status === punchStatuses.open && (
        <div style={{ alignItems: "center", display: "flex" }}>
          <AccountAlertIcon /> {status} {countSection}
        </div>
      )}
      {status === punchStatuses.cleared && (
        <div style={{ alignItems: "center", display: "flex" }}>
          <AccountCheckIcon /> {status} {countSection}
        </div>
      )}
      {status === punchStatuses.closed && (
        <div style={{ alignItems: "center", display: "flex" }}>
          <CheckIcon /> {status} {countSection}
        </div>
      )}
      {status === punchStatuses.favorites && (
        <div style={{ alignItems: "center", display: "flex" }}>
          <StarIcon /> {status} {countSection}
        </div>
      )}
      {status === punchStatuses.assignedToYou && (
        <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
          <ClipboardAccountIcon /> {status} {countSection}
        </div>
      )}
    </div>
  );
}

const container = (offsetBottom) => css`
  font-weight: 700;

  svg {
    width: 1.25rem;
    height: 1.25rem;
    margin-bottom: ${offsetBottom ? "-0.25rem" : 0};
  }

  &.Open {
    color: ${colors.red};
  }
  &.Cleared {
    color: ${colors.vividBlue};
  }
  &.Closed {
    color: ${colors.green};
  }
  &.Favorites {
    color: #103447;
  }
  &.AssignedToYou {
    color: #103447;
  }
`;

export default PunchStatus;
